import { ProjectVideo } from '../../../design-gosha/site/src/ProjectVideo'
import { videoProjects } from '../../../design-gosha/site/src/video-projects'
import { siteConfig } from '@/config/site'

const selectedProjects = videoProjects.filter(project =>
  project.id === 'netflix-streaks' || project.id === 'united-custom-web'
)

export const HomeSelectedWork = () => (
  <section aria-labelledby="selected-work-heading" className="mx-auto w-full max-w-[448px] px-4">
    <div className="flex items-start justify-between gap-3 pb-5">
      <h2 id="selected-work-heading" className="font-['Familjen_Grotesk'] text-[20px] font-normal leading-6 tracking-[-0.2px] text-[var(--foreground)]">
        Selected Work
      </h2>
      <a
        href={siteConfig.workIndexUrl}
        aria-label="View all work"
        className="shrink-0 font-['Familjen_Grotesk'] text-[20px] font-normal leading-6 tracking-[-0.2px] text-[var(--foreground-muted)] underline decoration-[var(--foreground-muted)] underline-offset-[3px] transition-colors duration-150 hover:text-[var(--foreground)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2"
      >
        View All
      </a>
    </div>
    <div className="grid grid-cols-2 items-start gap-2.5">
      {selectedProjects.map(project => (
        <a
          key={project.id}
          href={project.path}
          aria-label={`${project.title} case study`}
          className="group block min-w-0 rounded-[7px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-4"
        >
          <ProjectVideo project={project} preview />
          <h3 className="mt-2 font-['Familjen_Grotesk'] text-[16px] font-normal leading-5 tracking-[-0.16px] text-[var(--foreground)] group-hover:underline group-hover:underline-offset-4">
            {project.title}
          </h3>
        </a>
      ))}
    </div>
  </section>
)
